var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "620px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.closeHandler
      }
    },
    [
      _c("check-result-display", {
        attrs: { "current-state": _vm.currentState, title: _vm.title }
      }),
      _vm.dataSource.length > 0
        ? _c(
            "div",
            { staticClass: "single-wrap" },
            [
              _c(
                "el-scrollbar",
                [
                  _vm.currentState != "checking" && _vm.dataSource.length > 0
                    ? _c("check-item-renderer", {
                        attrs: {
                          data: _vm.dataSource,
                          "data-type": _vm.dataType
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !!_vm.remark
        ? [
            _c("el-divider"),
            _c("div", [_vm._v(" " + _vm._s(_vm.remark) + " ")])
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "app-main-inner-row", staticStyle: { padding: "0px" } },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.labelRemark.visible,
                  expression: "labelRemark.visible"
                }
              ],
              staticStyle: { color: "red", "line-height": "24px" }
            },
            [_vm._v(_vm._s(_vm.labelRemark.text))]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.labelRemark2.visible,
                  expression: "labelRemark2.visible"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.labelRemark2.text))]
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.areaRemark.visible,
              expression: "areaRemark.visible"
            }
          ]
        },
        [
          _c("el-input", {
            attrs: {
              no: "1",
              disabled: !_vm.areaRemark.editable,
              type: "textarea",
              row: 5
            },
            model: {
              value: _vm.areaRemark.text,
              callback: function($$v) {
                _vm.$set(_vm.areaRemark, "text", $$v)
              },
              expression: "areaRemark.text"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row", staticStyle: { padding: "0px" } },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.labelRejectRemark.visible,
                  expression: "labelRejectRemark.visible"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.labelRejectRemark.text))]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.labelRejectRemark2.visible,
                  expression: "labelRejectRemark2.visible"
                }
              ],
              staticStyle: { color: "red" }
            },
            [_vm._v(_vm._s(_vm.labelRejectRemark2.text))]
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.areaRejectRemark.visible,
              expression: "areaRejectRemark.visible"
            }
          ]
        },
        [
          _c("el-input", {
            attrs: {
              no: "2",
              disabled: !_vm.areaRejectRemark.editable,
              type: "textarea",
              row: 5
            },
            model: {
              value: _vm.areaRejectRemark.text,
              callback: function($$v) {
                _vm.$set(_vm.areaRejectRemark, "text", $$v)
              },
              expression: "areaRejectRemark.text"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "split-empty-div" }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.btn.showAgreeButton,
                  expression: "btn.showAgreeButton"
                }
              ],
              attrs: { no: "3", type: "primary" },
              on: { click: _vm.submitAgreeHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Agree")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.btn.showRefuseButton,
                  expression: "btn.showRefuseButton"
                }
              ],
              attrs: { no: "4", type: "danger" },
              on: { click: _vm.submitRefuseHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refuse")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.btn.showSubmitAuditButton,
                  expression: "btn.showSubmitAuditButton"
                }
              ],
              attrs: { no: "5", type: "primary" },
              on: { click: _vm.submitAuditHandler }
            },
            [_vm._v(_vm._s(_vm.$t("Message.SubmitAudit")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.btn.showConfirmButton &&
                    _vm.currentState !== _vm.states.failure &&
                    _vm.currentState !== _vm.states.checking,
                  expression:
                    "btn.showConfirmButton && currentState!==states.failure && currentState!==states.checking"
                }
              ],
              attrs: { no: "6", type: "primary" },
              on: { click: _vm.continueHandler }
            },
            [_vm._v(_vm._s(_vm.btn.confirmText))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.btn.showCloseButton,
                  expression: "btn.showCloseButton"
                }
              ],
              attrs: { no: "7", type: "danger" },
              on: { click: _vm.closeHandler }
            },
            [_vm._v(_vm._s(_vm.btn.closeText))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }